<app-multi-select-btn 
    [label]="'Phases'"
    [list]="phases"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>
